import { useEffect, useRef, useState } from "react";
import { BREAKPOINTCONFIG } from "../constants/breakpoints";

const WINDOW_RESIZE_DEBOUNCE = 200;

export default function useWindowResize(maxMobileWidth = BREAKPOINTCONFIG.md) {
    const [width, setWidth] = useState(window.innerWidth);
    const [_isMobile, _setIsMobile] = useState(window.innerWidth <= maxMobileWidth);
    const timeInterval = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            clearInterval(timeInterval.current);
            timeInterval.current = setInterval(() => {
                const { innerWidth } = window;

                clearInterval(timeInterval.current);
                setWidth(innerWidth);
                _setIsMobile(innerWidth < maxMobileWidth);
            }, WINDOW_RESIZE_DEBOUNCE);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [maxMobileWidth]);

    return { width, isMobile: _isMobile };
}
